import {
  faFileAlt,
  faBoxOpen,
  faScrewdriverWrench,
  faCommentAlt,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const maintenanceFields = [
  {
    section: "Informações da Manutenção",
    fields: [
      createField({
        id: "maintenance.maintenance_date",
        label: "Data da Manutenção",
        placeholder: "Selecione a data da manutenção",
        type: "date",
        icon: faScrewdriverWrench,
        isClearable: true,
      }),
      createField({
        id: "maintenance.equipment_id",
        label: "Equipamento",
        placeholder: "Selecione o equipamento",
        type: "select",
        isClearable: true,
        fullWidth: false,
        icon: faScrewdriverWrench,
      }),
      createField({
        id: "maintenance.product_item_id",
        label: "Insumo",
        placeholder: "Selecione o insumo",
        type: "select",
        isClearable: true,
        icon: faScrewdriverWrench,
      }),
      createField({
        id: "maintenance.product_quantity",
        label: "Quantidade",
        placeholder: "Informe a quantidade que irá para manutenção",
        type: "number",
        fullWidth: true,
        isNumericFormat: true,
        icon: faBoxOpen,
      }),
      createField({
        id: "maintenance.details",
        label: "Motivo da Manutenção",
        type: "textarea",
        fullWidth: true,
        placeholder: "Digite o motivo da manutenção",
        icon: faFileAlt,
      }),
    ],
  },
  {
    section: "Serviços",
    array: true,
    fields: [
      createField({
        id: "items.maintenance_type_id",
        label: "Tipo de Manutenção",
        placeholder: "Selecione o tipo de manutenção",
        type: "select",
        fullWidth: true,
        icon: faScrewdriverWrench,
        isClearable: true,
      }),
      createField({
        id: "items.maintenance_status_id",
        label: "Status da Manutenção",
        placeholder: "Selecione o status de manutenção",
        type: "select",
        icon: faScrewdriverWrench,
        isClearable: true,
      }),
      createField({
        id: "items.technician_status_id",
        label: "Situação",
        placeholder: "Selecione a situação",
        type: "select",
        icon: faScrewdriverWrench,
        isClearable: true,
      }),
      createField({
        id: "items.details",
        label: "Detalhes do Serviço",
        type: "textarea",
        placeholder: "Digite os detalhes",
        icon: faScrewdriverWrench,
        fullWidth: true,
      }),
    ],
  },
];

export const addItemsMaintenance = [
  {
    section: "Serviços",
    fields: [
      createField({
        id: "items.maintenance_type_id",
        label: "Tipo de Manutenção",
        placeholder: "Selecione o tipo de manutenção",
        type: "select",
        fullWidth: true,
        icon: faScrewdriverWrench,
        isClearable: true,
      }),
      createField({
        id: "items.maintenance_status_id",
        label: "Status da Manutenção",
        placeholder: "Selecione o status de manutenção",
        type: "select",
        icon: faScrewdriverWrench,
        isClearable: true,
      }),
      createField({
        id: "items.technician_status_id",
        label: "Situação",
        type: "select",
        placeholder: "Selecione a situação",
        icon: faScrewdriverWrench,
        isClearable: true,
      }),
      createField({
        id: "items.details",
        label: "Detalhes do Serviço",
        type: "textarea",
        placeholder: "Digite os detalhes",
        icon: faScrewdriverWrench,
        isClearable: true,
        fullWidth: true,
      }),
    ],
  },
];

export const closeMaintenanceFields = [
  {
    section: "Defina o destino do/s equipamento/s da manutenção",
    fields: [
      createField({
        id: "maintenance.destination",
        label: "Destino",
        type: "select",
        placeholder: "Selecione o destino",
        icon: faScrewdriverWrench,
        fullWidth: true,
        notRequired: true,
        isClearable: true,
      }),
    ],
  },
];

export const detailsMaintenanceFields = [
  {
    section: "Informações da Manutenção",
    fields: [
      createField({
        id: "maintenance.equipment",
        label: "Equipamento",
        type: "text",
        icon: faBoxOpen,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: "maintenance.product",
        label: "Insumo",
        type: "text",
        icon: faBoxOpen,
        disabled: true,
      }),
      createField({
        id: "maintenance.product_quantity",
        label: "Quantidade",
        type: "text",
        icon: faBoxOpen,
        disabled: true,
      }),
      createField({
        id: "maintenance.details",
        label: "Motivo da Manutenção",
        type: "textarea",
        fullWidth: true,
        placeholder: "Digite o motivo da manutenção",
        icon: faFileAlt,
        disabled: true,
      }),
      createField({
        id: "maintenance.extra_observation",
        label: "Obervação Extra",
        type: "textarea",
        fullWidth: true,
        disabled: true,
        placeholder: "Digite a obervação extra",
        icon: faCommentAlt,
      }),
    ],
  },
];
